import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { styles } from '@ui/components/TanstackTable';
import { useQuoteLineContext } from '@ui/features/quote-builder/components/QuoteLine/QuoteLineProvider';
import { selectQuoteLineWithLeadTimeIssues } from '@ui/features/quote-builder/state/selectors/quote-line';
import { useSelector } from '@ui/hooks/useSelector';

import { operationHeaders, OperationRow } from './OperationRow';

export function CostEstimator() {
  const { quoteLineUuid } = useQuoteLineContext();

  const { snapWorkOrder } = useSelector((state) =>
    selectQuoteLineWithLeadTimeIssues(state, quoteLineUuid),
  );

  if (!snapWorkOrder) {
    return null;
  }

  return (
    <Box width="100%" overflow="hidden">
      <TableContainer width="100%" mb={4}>
        <Table width="100%" sx={styles} size="sm">
          <Thead>
            <Tr>
              {operationHeaders.map((header) => (
                <Th key={header}>{header}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {snapWorkOrder.snapOperationUuids.map((uuid) => (
              <OperationRow key={uuid} snapOperationUuid={uuid} />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}
